import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination, TextField, Avatar } from '@mui/material';
import { Edit, Delete, Visibility } from '@mui/icons-material';
import { Necropolis } from '../../types';

interface NecropolisTableProps {
  items: Necropolis[];
  loading: boolean;
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onEdit: (item: Necropolis) => void;
  onDelete: (id: number) => void;
}

export function NecropolisTable({ items, loading, total, page, limit, onPageChange, onEdit, onDelete }: NecropolisTableProps) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Портрет</TableCell>
            <TableCell>Имя</TableCell>
            <TableCell>Сан</TableCell>
            <TableCell>Годы жизни</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell>
                <Avatar 
                  src={item.portraitUrl} 
                  alt={item.name}
                  sx={{ width: 40, height: 40 }}
                />
              </TableCell>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.rank || '-'}</TableCell>
              <TableCell>{item.years || '-'}</TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Просмотр">
                    <IconButton size="small" onClick={() => onEdit(item)}>
                      <Visibility fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Редактировать">
                    <IconButton size="small" onClick={() => onEdit(item)}>
                      <Edit fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Удалить">
                    <IconButton size="small" onClick={() => onDelete(item.id)} sx={{ color: 'error.main' }}>
                      <Delete fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && !loading && (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography color="text.secondary">Данные не найдены</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={total}
        page={page - 1}
        onPageChange={(_, newPage) => onPageChange(newPage + 1)}
        rowsPerPage={limit}
        onRowsPerPageChange={() => {}}
        rowsPerPageOptions={[]}
      />
    </TableContainer>
  );
}

interface NecropolisToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
}

export function NecropolisToolbar({ search, onSearchChange }: NecropolisToolbarProps) {
  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
      <TextField
        label="Поиск по имени"
        variant="outlined"
        size="small"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ minWidth: 200 }}
      />
    </Box>
  );
}